import {Box, Heading, HStack, Show, VStack} from 'platform/foundation';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {MakeLogo} from '../../MakeLogo/MakeLogo';
import {SourcingCebiaReportBadge} from '../../SourcingCebiaReport/components/SourcingCebiaReportBadge';
import {SpecificationItem} from '../types/SpecificationItem';
import {SpecificationChips} from './SpecificationChips';

/** 8 space steps = 32px - recognisable without taking width from the title. */
const MAKE_LOGO_SIZE = 8;

interface ListingTitleProps extends TestIdProps {
  title: string | Nullish;
  /** Catalogue make key; the logo is left out when the catalogue has none. */
  make: string | Nullish;
  specifications: SpecificationItem[];
  cebiaReportExternalId?: string;
}

export function ListingTitle(props: ListingTitleProps) {
  return (
    <VStack spacing={3}>
      <HStack spacing={3} align="center">
        <MakeLogo
          make={props.make}
          size={MAKE_LOGO_SIZE}
          data-testid={suffixTestId('makeLogo', props)}
        />
        <Box flex={1} minWidth={0}>
          <Heading size={2} overflowWrap="anywhere" data-testid={suffixTestId('title', props)}>
            {props.title}
          </Heading>
        </Box>
        <Show when={props.cebiaReportExternalId}>
          {(externalId) => <SourcingCebiaReportBadge externalId={externalId} />}
        </Show>
      </HStack>
      <SpecificationChips
        items={props.specifications}
        data-testid={suffixTestId('specifications', props)}
      />
    </VStack>
  );
}
